<template style="display: flex">
    <v-card style="width: 60%; margin:0 auto; padding:12px" light>
        <v-card-title class="card-title ma-0 pa-3">
            <v-row class="ma-0 pa-0">
                <v-col cols="auto" class="ma-0 pa-0">
                    <span>Confirm Removing User</span>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="auto" class="ma-0 pa-0">
                    <v-icon @click="close">mdi-close</v-icon>
                </v-col>
            </v-row>
        </v-card-title>
        <v-card-text>
            <v-row class="ma-0 pa-0">
                <v-col cols="auto" class="ma-0 pa-0">
                Are you sure you want to remove the user <b>{{ user.name }}</b> from the organization <b>{{ org.display_name }}</b>?
                </v-col>
            </v-row>
        </v-card-text>
        <v-row class="ma-0 pa-0" justify="space-around">
            <v-col cols="auto" >
                <v-btn color='secondary' outlined class="card-action" @click="close">
                    Cancel
                </v-btn>
            </v-col>
            <v-col cols="auto" @click="confirmed_remove_member">
                <v-btn color='secondary' class="card-action">
                    Confirm
                </v-btn>
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
export default {
    name: 'RemoveUserCard',
    props: [
        'user',
        'org'
    ],

    methods: {
        close: function() {
            this.$emit("close_remove_user")
        },
        confirmed_remove_member: function() {
            this.$emit("remove_member_from_org")
        }
    }
}
</script>
<style>
    .card-title{
        font-family: 'Gothic' !important;
        font-weight: 800 !important;
        font-size: 1.2em !important;
    }
    .card-section-title{
        font-family: 'Gothic' !important;
        font-weight: 600 !important;
        font-size: 1.2em !important;
    }
    .card-action{
        font-family: 'Gothic' !important;
        font-weight: 400 !important;
        font-size: 0.9em !important;
    }
</style>
  